/**
 * Devuelve el controller del formBuilder si lo encuentra en el scope o uno de sus padres
 *
 * @param {object} scope el scope original a partir del cual buscamos el controller
 * @param {int} max (OPTIONAL) indica un maximo para limitar la busqueda
 */
export function searchEcFormBuilderController(scope, max = 15) {
  while (scope && !scope.hasOwnProperty('ecFormBuilderController') && max--) {
    scope = scope.$parent;
  }
  if (!scope || !scope.ecFormBuilderController) {
    throw new Error(`ecFormBuilderController not found in scope parents`);
  }
  return scope.ecFormBuilderController;
}
